import { z } from "zod";
import type { ApiClient } from "@/lib/api";

const UpdateSecretRequestSchema = z.object({
  value: z.string().min(1, "Value is required").optional(),
  description: z.string().nullable().optional(),
});
export type UpdateSecretRequest = z.infer<typeof UpdateSecretRequestSchema>;

export const updateSecret = async (options: {
  client: ApiClient;
  id: string;
  secret: UpdateSecretRequest;
}) => {
  const { client, id, secret } = options;
  const { data } = await client.put(`/secrets/${id}`, secret);
  return data;
};
